import { render, staticRenderFns } from "./rulesList.vue?vue&type=template&id=41e631c3&scoped=true"
import script from "./rulesList.vue?vue&type=script&lang=js"
export * from "./rulesList.vue?vue&type=script&lang=js"
import style0 from "./rulesList.vue?vue&type=style&index=0&id=41e631c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e631c3",
  null
  
)

export default component.exports